<template lang="html">
  <section class="buscador-marcas">
    <div class="container">
      <form class="search flex wrap" @submit.prevent>
        <input
          type="text"
          class="input-text"
          :placeholder="$t('catalogo.buscador.placeholder')"
          v-model="search"
        />
      </form>

      <ul class="abc flex wrap justify-between" v-if="!!data">
        <li v-for="(val,key) in activeLetters" :key="key">
          <a @click="setToShow(key)" :class="[{'off' : !val}]">{{ key }}</a>
        </li>
      </ul>

      <div class="results">
         <p v-if="el_to_show == ''">
              {{$t('catalogo.buscador.titulo')}}
        </p>
        <template v-for="(group, key) in groupDocuments">
         
          <div
            v-if="el_to_show == key || search "
            :id="key"
            class="letter-in flex row justify-start"
          >
            <div class="letter-xl align-stretch">
              <span>{{ key }}</span>
            </div>
            <div class="letter-items flex wrap justify-start">
              <template v-for="document in group">
                <a
                  class="document-el"
                  :href="getServer+'bundles/prensa/descargables/public/pdfsretenes/'+document.archivo"
                  v-html="document.titulo"
                  target="_blank"
                ></a>
              </template>
            </div>
          </div>
        </template>
      </div>

      <div class="zero-result" v-if="Object.keys(groupDocuments).length == 0">
        <h3 class="title title-36">{{ $t("genericos.no_resultados") }}</h3>
      </div>
    </div>
  </section>
</template>

<script lang="js">

  import Vue from 'vue'
  import axios from 'axios'
  import VueAxios from 'vue-axios'

  Vue.use(VueAxios, axios);

  import {mapGetters} from 'vuex';

  export default  {
    name: 'buscador',
    props: [],
    created() {
      axios.get(`pdfsretenes`)
      .then(response => {
        this.data = response.data.pdfs;
      })
      .catch(error => console.log(error));
    },
    data() {
      return {
        data : '',
        search : '',
        letters:{"a":false,"b":false,"c":false,"d":false,"e":false,"f":false,"g":false,"h":false,"i":false,"j":false,"k":false,"l":false,"m":false,"n":false,"o":false,"p":false,"q":false,"r":false,"s":false,"t":false,"u":false,"v":false,"w":false,"x":false,"y":false,"z":false},
        el_to_show : ''
      }
    },
    methods: {
        setToShow : function (el) {
                    console.log(el);
                    this.el_to_show = el;
                  }
          },

    computed: {
      ...mapGetters(['getServer', 'getLanguage']),
      documentOrder : function(){
        let documents = this.data || false;

        if(!!documents){
        //   documents.sort(function (a, b) {
        //    return a.titulo > b.titulo;
        //  })
        }
        return documents;
      },
      filteredDocuments : function (){
        let documents;

        if(!!this.search){
          documents = this.documentOrder.filter(d => d.titulo.toLowerCase().includes(this.search.toLowerCase()))
         
        }else{
          documents = this.documentOrder;
        }

        return documents;
      },
      activeLetters : function(){

        for(let l in this.letters){
          this.letters[l] = false;
        }

        this.filteredDocuments.forEach(d =>{
          let char = d.titulo.charAt(0).toLowerCase();
          this.letters[char] = true;
        });

        return this.letters;
      },
      groupDocuments : function(){

        let documents = this.filteredDocuments;

        let lettersActive = {};

        for(let l in this.letters){
          (this.letters[l]) ? lettersActive[l] = new Array() : '';
        }

        if(Object.keys(lettersActive).length > 0){
          documents.forEach(d => {
            let char = d.titulo.charAt(0).toLowerCase();
            if(!!lettersActive[char]){
              lettersActive[char].push(d);
            }
          });
        }

        return lettersActive;

      }
    }
  }
</script>

<style scoped>
  .document-el {
    color: #054279;
    margin-top: 3px;
    padding-left: 40px;
    background: url(/static/img/archive.svg) center left/23px no-repeat;
    text-transform: uppercase;
    width: 33.333333333%;
    height: 30px;
    line-height: 30px;
  }

  .results {
    margin-bottom: 0;
  }

  .buscador-marcas {
    padding: 100px 0;
    padding-top: 50px;
  }

  @media screen and (max-width: 700px) {
    .document-el {
      width: 100%;
    }
    .buscador-marcas {
      padding: 20px 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/view-parts/catalogo-parts/buscador-retenes.vue